/** Mutates every <a> under root to open in a new tab with tabnabbing-safe rel tokens. */
export function applyLinkSafetyToDom(root: ParentNode): void {
  const anchors = root.querySelectorAll('a');
  anchors.forEach(anchor => {
    anchor.setAttribute('target', '_blank');
    const existing = anchor.getAttribute('rel') ?? '';
    const tokens = new Set(
      existing
        .split(/\s+/)
        .map(t => t.toLowerCase())
        .filter(t => t.length > 0)
    );
    tokens.add('noopener');
    tokens.add('noreferrer');
    anchor.setAttribute('rel', Array.from(tokens).join(' '));
  });
}

/** Rewrites anchor elements in an HTML string to open safely in a new tab. */
export function enforceLinkSafety(html: string): string {
  if (html === '') {
    return '';
  }
  const container = document.createElement('div');
  container.innerHTML = html;
  applyLinkSafetyToDom(container);
  return container.innerHTML;
}
